export const getCanonicalURL = (url) => url.replace(/(^[^(\\?|#)]+)(?:\\?|#).*/, '$1').replace(/\/+$/g, '')
